import React, { useContext, useEffect, useState } from "react";
import VerticalNavigation from "../components/VerticalNavigation";
import Dropdown from "../components/Dropdown";
import AuthContext from "../context/AuthContext";
import Swal from "sweetalert2";




const DataPreprocessing = () => {
  const { authTokens } = useContext(AuthContext);
  const [rwdata, setRwData] = useState();
  // const [processdata, setProcessData] = useState();
  const impute_attrs = [
    {
      value: "select",
      label: "--Select--",
    },
    {
      value: "drop",
      label: "Drop Columns",
    },
    {
      value: "droprows",
      label: "Drop Records",
    },
    {
      value: "mean",
      label: "Impute with Mean",
    },
    {
      value: "median",
      label: "Impute with Median",
    },
    {
      value: "mode",
      label: "Impute with Mode",
    },
  ];

  const trans_attrs = [
    {
      value: "select",
      label: "--Select--",
    },
    {
      value: "label encoder",
      label: "Label Encoder",
    },
    {
      value: "get dummies",
      label: "Get Dummies",
    },
  ];

  useEffect(() => {
    dataPreprocessing();
  });

  
  // imputation
  const initimpute = impute_attrs[0].label;
  const [imputAttribute, setImputeAttribute] = useState(initimpute);

  // trasform
  const inittrans = trans_attrs[0].label;
  const [transattribute, setTransAttribute] = useState(inittrans);

  let dataPreprocessing = async () => {
  const Swal = require('sweetalert2');

    let response = await fetch(`${process.env.REACT_APP_URL}/data_preprocessing/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + String(authTokens.access),
      },
    });
    let data = await response.json();
    if (response.status === 200) {
      // console.log("Data Preprocessing", data["null_data"]);
      setRwData(data);
    }
  };

  let imputationPreprocessing = async () =>{
    let response = await fetch(`${process.env.REACT_APP_URL}/imputation_preprocessing/`,{
      method:'POST',
      headers: {
        "Content-Type":"application/json",
        Authorization: "Bearer "+String(authTokens.access),
      },
      body: JSON.stringify({
        imputAttribute,
      }),
    });
    let data = await response.json();
    if (response.status === 200)
    {
      // console.log('imputation done!');
      // setRwData(data);
      Swal.fire({
        title:'Success',
        text:'Imputation have done!',
        icon: 'success',
        confirmButtonText: 'Ok'
      })
      if (data['Status'] === 'Already Done'){
        // alert(data['Msg']);
        Swal.fire({
          title:'Success',
          text:'Imputation already have done!',
          icon: 'info',
          confirmButtonText: 'Ok'
        })

      }
      else if (data['Status'] === 'No Need'){
        // alert(data['Msg']);
        Swal.fire({
          title:'Success',
          text:'No need to perform Imputation.',
          icon: 'info',
          confirmButtonText: 'Ok'
        })
      }
    }
  }

  let transPreprocessing = async() =>{
    let response = await fetch(`${process.env.REACT_APP_URL}/transformation_preprocessing/`,{
      method:'POST',
      headers:{
        'Content-Type':'application/json',
        Authorization: 'Bearer '+String(authTokens.access),
      },
      body:JSON.stringify({transattribute})
    });
    let data = await response.json();
    if (response.status === 200){
      Swal.fire({
        title:'Success',
        text:'Transformation have done!',
        icon: 'success',
        confirmButtonText: 'Ok'
      })
      // console.log('Transformation used....')
      if (data['Status'] === 'Already Done')
      {
        // alert(data['Msg']);
        Swal.fire({
          title:'Success',
          text:'Transformation have already done!!',
          icon: 'info',
          confirmButtonText: 'Ok'
        })
      }
      else if (data['Status'] === 'Failed'){
        // alert(data['Error']);
        Swal.fire({
          title:'Success',
          text:data['Error'],
          icon: 'error',
          confirmButtonText: 'Ok'
        })
      }
    }
  }


  // hooks
  useEffect(()=> {
    if(imputAttribute === 'drop'){
      alert('Attention!--> Data would be reduced.');
      imputationPreprocessing();
    }else if(imputAttribute === 'droprows'){
     alert('Attention!--> Data would be reduced');
     imputationPreprocessing();
    } else if(imputAttribute !== '--Select--') {
    imputationPreprocessing();}
  },[imputAttribute])

  useEffect(()=>{
    transPreprocessing();
  },[transattribute])
  return (
    <>
      <div className="wrapper">
        <VerticalNavigation />
        <div className="container bg-light rounded main_content mx-2">
          <div className="modal-body">
            <ul className="nav nav-tabs" role="tablist">
              {/* <li className="nav-item">
                <a
                  className="nav-link active"
                  data-bs-toggle="tab"
                  href="#correcting"
                  role="tab"
                >
                  <span className="d-none d-sm-block">Correcting</span>
                </a>
              </li> */}
              <li className="nav-item">
                <a
                  className="nav-link "
                  data-bs-toggle="tab"
                  href="#completing"
                  role="tab"
                >
                  <span className="d-none d-sm-block">Completing</span>
                </a>
              </li>
              {/* <li className="nav-item">
                <a
                  className="nav-link "
                  data-bs-toggle="tab"
                  href="#outlier"
                  role="tab"
                >
                  <span className="d-none d-sm-block">Correcting</span>
                </a>
              </li> */}
              <li className="nav-item">
                <a
                  className="nav-link"
                  data-bs-toggle="tab"
                  href="#converting"
                  role="tab"
                >
                  <span className="d-none d-sm-block">Converting</span>
                </a>
              </li>
            </ul>

            {/* <!-- Tab panes --> */}
            <div className="tab-content p-3">
              {/* <div className="tab-pane active" id="correcting" role="tabpanel">
                <h3 className="text-center">Correcting....</h3>
                <div className="d-flexjustify-content-between flex-wrap"></div>
              </div> */}
              <div className="tab-pane" id="outlier" role="tabpanel">
                <h3 className="text-center">Handling Outlier...</h3>
                <div className="d-flex justify-content-between flex-wrap"></div>
              </div>
              <div className="tab-pane active" id="completing" role="tabpanel">
                <h3 className="text-center">Completing....</h3>
                <div className="d-flexjustify-content-between flex-wrap">
                  <div className="col-4">
                    <form className="text-center">
                      <div className="d-flex">
                        <div>
                          <h4>Imputation of Missing Value:</h4>
                        </div>
                        <div className="mx-5">
                          <Dropdown
                            options={impute_attrs}
                            id="imptute"
                            selectedValue={imputAttribute}
                            onSelectedValueChange={setImputeAttribute}
                          />
                        </div>
                      </div>
                    <div className="table-fixedhead text-center mb-5 py-3">
                        <table className="my-5">
                          <thead>
                            <tr>
                              <th>Features Name</th>
                              <th>Null Count</th>
                            </tr>
                          </thead>
                          <tbody>
                            {rwdata &&
                              Object.keys(rwdata["null_data"]).map((itm, i) => (
                                <tr key={i}>
                                  <th>{itm}</th>
                                  <td>{rwdata["null_data"][itm]}</td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <div className="tab-pane" id="converting" role="tabpanel">
                <h3 className="text-center">Converting....</h3>
              <div className="justify-content-between flex-wrap">
                  <div className="">
                    <div className="d-flex">
                      <div className="">
                        <h4 className="">Converting Methods</h4>
                      </div>
                      <div className="mx-5">
                        <Dropdown
                          options={trans_attrs}
                          id="trans"
                          selectedValue={transattribute}
                          onSelectedValueChange={setTransAttribute}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="table-fixedhead mb-5">
                    {rwdata && (
                      <table className="table-bordered px-3">
                        <thead>
                          <tr>
                            {rwdata["features"].map((item) => (
                              <th scope="col">{item}</th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {rwdata["data"].slice(1, 10).map((item) => (
                            <tr>
                              {item.map((itm) => (
                                <td>{itm}</td>
                              ))}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* <h3 className="text-center my-5">
            Thanks For Visit Data Vizualizaton Page. content is coming
            soon........
          </h3> */}
          {/* <Scatterplot plotdata={plotdata} /> */}
        </div>
      </div>
    </>
  );
};

export default DataPreprocessing;
